const params = new URLSearchParams(window.location.search);

if (params.get('type') === 'team-order' && /\/pages\/contact\/?$/.test(window.location.pathname)) {
  for (const details of document.querySelectorAll('[data-team-quote]')) {
    if (!(details instanceof HTMLFieldSetElement)) continue;
    const form = details.closest('form');
    if (!form) continue;

    details.hidden = false;
    details.disabled = false;
    form.dataset.teamQuoteActive = 'true';

    const product = details.querySelector('[data-team-product]');
    if (product instanceof HTMLInputElement && !product.value) {
      product.value = (params.get('product_title') || params.get('product')?.replaceAll('-', ' ') || '').slice(0, 160);
    }

    const message = form.querySelector('textarea[name="contact[body]"]');
    if (message instanceof HTMLTextAreaElement) {
      message.placeholder = 'Community, personalization and anything else we should know.';
      message.rows = 5;
    }

    const submit = form.querySelector('button[type="submit"]');
    if (submit) submit.textContent = 'Request a quote';
  }

  const title = document.querySelector('main h1');
  if (title) title.textContent = 'Team order quote';
}
